import { useTranslation } from "react-i18next";
import { Controller, UseFormMethods } from "react-hook-form";
import { format, max, min } from "date-fns";
import { IPortinSlot } from "@features/PortIn/interface/IPortinSlot";
import { IPortinForm } from "@features/PortIn/interface/IPortinForm";
import { MobileDatePicker } from "@mui/x-date-pickers";
import { TextField, TextFieldProps } from "@mui/material";

interface IParams {
    formMethod: UseFormMethods<IPortinForm>;
    fullWidth?: boolean;
    portinSlotList: IPortinSlot[];
}

export const PortInDate = (props: IParams) => {
    const { formMethod, portinSlotList, fullWidth } = props;
    const { errors, control } = formMethod;
    const { t } = useTranslation(["portin", "validation"]);

    // Empty array passed to min or max will result in invalid date which cannot be formatted
    const portinSlotDateList = portinSlotList.length
        ? portinSlotList.map((portinSlot) => portinSlot.date)
        : [new Date()];
    const portinMinDate = min(portinSlotDateList);
    const portinMaxDate = max(portinSlotDateList);

    return (
        <Controller
            control={control}
            name="date"
            render={(controllerProps) => (
                <MobileDatePicker
                    closeOnSelect
                    inputFormat="dd/MM/yyyy"
                    label={`${t("portin:moveDate")} *`}
                    maxDate={portinMaxDate}
                    minDate={portinMinDate}
                    renderInput={(renderProps: TextFieldProps) => (
                        <TextField
                            {...renderProps}
                            className="xtest_date_input"
                            error={Boolean(errors.date)}
                            fullWidth={fullWidth}
                            helperText={errors.date?.message}
                            id="moveDate"
                            inputRef={controllerProps.ref}
                            name="date"
                            placeholder={format(portinMinDate, "dd/MM/yyyy")}
                            variant="standard"
                        />
                    )}
                    showToolbar={false}
                    value={controllerProps.value}
                    onChange={controllerProps.onChange}
                />
            )}
            rules={{
                required: t("validation:required"),
            }}
        />
    );
};
